"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metaTitleSeo = metaTitleSeo;
/**
 * meta title factory
 * @param {String} name
 * @param {String} city
 * @param {Number} year
 * @param {String} language
 * @returns {String}
 */

function metaTitleSeo(name, city, isRtl) {
  var year = new Date().getFullYear();
  return isRtl ? "\u062D\u062C\u0632 ".concat(name, "\u060C ").concat(city, "\u060C \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 ").concat(year, "\u060C \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0627\u062A \u0648\u0627\u0644\u0639\u0646\u0648\u0627\u0646") : "Book ".concat(name, ", ").concat(city, ", Updated ").concat(year, " Prices, Reviews & Address");
}